Apt.fn.extend('index', {}, {
	/**
	 * Calculate History scroll value
	 *
	 * @param {Object} conf
	 * @param {Object} results
	 * @returns {Boolean|Number}
	 */
	scrollTop(conf, results) {
		let top = conf.scrollTop;
		let offset = conf.scrollOffset;

		if (top === false) {
			return top;
		}

		if (typeof top === 'function') {
			top = top(results);
		}

		if (top === false) {
			return false;
		}

		if (Number.isFinite(top)) {
			return top;
		}

		if (typeof offset === 'function') {
			offset = offset();
		}

		return LS.util.getScroll(
			typeof top === 'string' ?
				top : conf.$target,
			offset
		);
	},

	/**
	 * Calculate History scroll target
	 *
	 * @param {Object} conf
	 * @returns {$}
	 */
	scrollTarget(conf) {
		if (conf.scrollTarget) {
			return LS.util.val(conf.scrollTarget);
		}

		return LS.util.scrollTarget();
	}
});